export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

export class PlanNotFoundError extends Error {
  override readonly name = 'PlanNotFoundError';
  constructor() {
    super('Nutrition plan not found');
  }
}

export class PlanOverlapError extends Error {
  override readonly name = 'PlanOverlapError';
  constructor() {
    super('Nutrition plan overlaps with an existing plan');
  }
}

export class InvalidPlanInputError extends Error {
  override readonly name = 'InvalidPlanInputError';
  constructor(message = 'Invalid nutrition plan input') {
    super(message);
  }
}

export type NutritionPlanError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | PlanNotFoundError
  | PlanOverlapError
  | InvalidPlanInputError;
